/**
 * Creates a fiction CPR number from user data
 * 
 * @param {any} { firstName, lastName, birthDate, gender } 
 * @returns {string}
 */
export function generateFictionalCPR({ firstName, lastName, birthDate, gender }) {
	const genderNumber = gender === 'M' ? 1 : 2;

	return `${birthDate}-${firstName.substring( 0, 2 )}${lastName.substring( 0, 1 )}${genderNumber}`;
}



// WEBPACK FOOTER //
// ./assets/_js/scripts/generateFictionalCPR.js